import { useState } from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white/80 backdrop-blur-md">
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2">
            <span className="text-2xl font-bold tracking-tight" style={{ fontFamily: "var(--font-heading)" }}>韩漫屋</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap">首页</Link>
            <Link to="/category/romance" className="text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap">分类</Link>
            <Link to="/about" className="text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap">关于我们</Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-background-100 transition-colors cursor-pointer" aria-label="搜索">
              <i className="ri-search-line text-lg text-foreground-700"></i>
            </button>
            <button className="px-5 py-2 text-sm font-medium rounded-full border-2 border-foreground-200 text-foreground-800 hover:border-foreground-400 hover:text-foreground-950 transition-all whitespace-nowrap cursor-pointer">
              登录
            </button>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-full hover:bg-background-100 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-lg text-foreground-700 ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-background-200 px-6 py-4 flex flex-col gap-3">
          <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-foreground-950 py-2" onClick={() => setMobileOpen(false)}>首页</Link>
          <Link to="/category/romance" className="text-sm font-medium text-foreground-700 hover:text-foreground-950 py-2" onClick={() => setMobileOpen(false)}>分类</Link>
          <Link to="/about" className="text-sm font-medium text-foreground-700 hover:text-foreground-950 py-2" onClick={() => setMobileOpen(false)}>关于我们</Link>
          <button className="px-5 py-2 text-sm font-medium rounded-full border-2 border-foreground-200 text-foreground-800 hover:border-foreground-400 transition-all text-center whitespace-nowrap cursor-pointer">
            登录
          </button>
        </div>
      )}
    </nav>
  );
}